<script>
import config from "./../config.js";
import { user } from './stores.js';
import { onMount } from 'svelte';
import { toLegendValue, toDateInputValue, removeHours } from './helpers/datetime.js';
import Drawer from './components/Drawer.svelte';
import Widget from './components/Widget.svelte';
import Alerts from './components/Alerts.svelte';
import Plot from './components/plot/Plot.svelte';

const graphs = [
  {name: "Temperature", key: "temperature laitdepoule", legend: "celcius", color: "#EE4266", width: 2}
];
const layout = {
  yaxis: {
    title: "Celsius",
    titlefont: { color: "#EE4266" },
    tickfont: { color: "#EE4266" }
  }
};

</script>

<Drawer />
<Alerts />

<div class="container">
  <Widget />

  <Plot graphs={graphs} layout={layout} />
</div>
